export const TASK_STATUS = {
  OPEN: 'OPEN',
  PLANNED: 'PLANNED',
  IN_PROGRESS: 'IN_PROGRESS',
  BLOCKED: 'BLOCKED',
  COMPLETED: 'COMPLETED',
  ARCHIVED: 'ARCHIVED',
};

export const TASK_STATUS_MAPPING = {
  [TASK_STATUS.OPEN]: { color: 'yellow', displayName: 'Open' },
  [TASK_STATUS.PLANNED]: { color: 'purple', displayName: 'Planned' },
  [TASK_STATUS.IN_PROGRESS]: { color: 'blue', displayName: 'In Progress' },
  [TASK_STATUS.BLOCKED]: { color: 'vermilion', displayName: 'Blocked' },
  [TASK_STATUS.COMPLETED]: { color: 'green', displayName: 'Completed' },
  [TASK_STATUS.ARCHIVED]: { color: 'grey', displayName: 'Archived' },
};

export const TASK_PRIORITY = {
  NONE: 'NONE',
  LOW: 'LOW',
  NORMAL: 'NORMAL',
  HIGH: 'HIGH',
  URGENT: 'URGENT',
};

export const TASK_ACTIVITY_TABS = {
  COMMENTS: 'COMMENTS',
  CHANGE_LOG: 'CHANGE_LOG',
  WORK_LOG: 'WORK_LOG',
};

export const TASK_PRIORITY_MAPPING = {
  [TASK_PRIORITY.NONE]: { value: 'None', flagState: 'none' },
  [TASK_PRIORITY.LOW]: { value: 'Low', flagState: 'low' },
  [TASK_PRIORITY.NORMAL]: { value: 'Normal', flagState: 'normal' },
  [TASK_PRIORITY.HIGH]: { value: 'High', flagState: 'high' },
  [TASK_PRIORITY.URGENT]: { value: 'Urgent', flagState: 'urgent' },
};

export const TASK_TYPE = {
  NORMAL: 'NORMAL',
  PLAYBOOK: 'PLAYBOOK',
  SCENARIO: 'SCENARIO',
  SUCCESS_PLAN: 'SUCCESS_PLAN',
};

export const CHANGE_TYPES = {
  CREATED: 'created',
  MODIFIED: 'edited',
  COMPLETED: 'completed',
};

export const CHANGELOG_TYPES = {
  TASK: 'task',
  PLAYBOOK_TEMPLATE: 'playbook',
  TASK_TEMPLATE: 'task template',
  PLAYBOOK_INSTANCE: 'applied playbook',
};

export const DEFAULT_TASK_EXTRA_PRE_FILTERS = {
  MY_ORGANIZATIONS: 'MY_ORGANIZATIONS',
  MY_ACCOUNTS: 'MY_ACCOUNTS',
};

export const DEFAULT_TASK_PRE_FILTER_KEYS = [
  ...Object.values(DEFAULT_TASK_EXTRA_PRE_FILTERS),
];

export const DEFAULT_TASK_FILTERS = [
  {
    presetDisplayName: 'Hide Archived',
    isPreset: true,
    attribute: {
      name: 'status',
      dataType: 'tags',
      displayName: 'Hide Archived',
    },
    filter: 'isSetTo',
    value: [
      TASK_STATUS.OPEN,
      TASK_STATUS.PLANNED,
      TASK_STATUS.IN_PROGRESS,
      TASK_STATUS.BLOCKED,
      TASK_STATUS.COMPLETED,
      null,
    ],
    presetId: 1,
  },
  {
    presetDisplayName: 'Hide Completed',
    isPreset: true,
    attribute: {
      name: 'status',
      dataType: 'tags',
      displayName: 'Hide Completed',
    },
    filter: 'isSetTo',
    value: [
      TASK_STATUS.OPEN,
      TASK_STATUS.PLANNED,
      TASK_STATUS.IN_PROGRESS,
      TASK_STATUS.BLOCKED,
      TASK_STATUS.ARCHIVED,
      null,
    ],
    presetId: 2,
  },
];

export const DEFAULT_TASK_PRESET_FILTER = [
  {
    displayName: 'Hide Archived',
    name: 'status',
    filter: 'isSetTo',
    value: [
      TASK_STATUS.OPEN,
      TASK_STATUS.PLANNED,
      TASK_STATUS.IN_PROGRESS,
      TASK_STATUS.BLOCKED,
      TASK_STATUS.COMPLETED,
      null,
    ],
    presetId: 1,
    key: 'STATUS_HIDE_ARCHIVED',
  },
  {
    displayName: 'Hide Completed',
    name: 'status',
    filter: 'isSetTo',
    value: [
      TASK_STATUS.OPEN,
      TASK_STATUS.PLANNED,
      TASK_STATUS.IN_PROGRESS,
      TASK_STATUS.BLOCKED,
      TASK_STATUS.ARCHIVED,
      null,
    ],
    presetId: 2,
    key: 'STATUS_HIDE_COMPLETED',
  },
  {
    displayName: 'My Organizations',
    name: 'linkedEntityType',
    filter: 'isSetTo',
    value: ['ORGANIZATION'],
    presetId: 3,
    key: DEFAULT_TASK_EXTRA_PRE_FILTERS.MY_ORGANIZATIONS,
  },
  {
    displayName: 'My Accounts',
    name: 'linkedEntityType',
    filter: 'isSetTo',
    value: ['ACCOUNT'],
    presetId: 4,
    key: DEFAULT_TASK_EXTRA_PRE_FILTERS.MY_ACCOUNTS,
  },
];

export const TASK_TYPE_MAPPING = {
  [TASK_TYPE.NORMAL]: { displayName: 'Normal' },
  [TASK_TYPE.PLAYBOOK]: { displayName: 'Playbook' },
  [TASK_TYPE.SCENARIO]: { displayName: 'Scenario' },
  [TASK_TYPE.SUCCESS_PLAN]: { displayName: 'Success Plan' },
};

export const MAX_WATCHER_COUNT = 10;
export const MAX_ATTACHMENT_COUNT = 10;

export const TASK_ASSIGNEE_TYPE = {
  USER: 'USER',
  CONTACT: 'CONTACT',
};

export const TASK_ASSIGNEE_CONTACT_TYPES = {
  CONTACT_TYPE_FIELD: 'CONTACT_TYPE_FIELD',
};

export const TASK_WATCHER_TYPE = {
  USER: 'USER',
  CONTACT: 'CONTACT',
};

export const END_RECURRENCE_PATTERN = {
  DATE: 1,
  MAX_OCCURRENCE: 2,
};

export const TASK_SOURCES = {
  ACTION_ITEM: 'ACTION_ITEM',
};

export const TASK_VIEW_MODE_QUERY_PARAM = 'view-mode';

export const TASK_VIEW_MODES = {
  LIST: 'list',
  BOARD_STATUS: 'board_status',
  BOARD_PRIORITY: 'board_priority',
};

export const TASK_STATUS_COLORS = {
  OPEN_COLOR: '#ffb000',
  PLANNED_COLOR: '#7b54fc',
  IN_PROGRESS_COLOR: '#0093FF',
  BLOCKED_COLOR: '#e28800',
  COMPLETE_COLOR: '#0abbb6',
};

export const TASK_PRIORITY_COLORS = {
  [TASK_PRIORITY.NONE]: '#959595',
  [TASK_PRIORITY.LOW]: '#09ACA8',
  [TASK_PRIORITY.NORMAL]: '#3FC0FF',
  [TASK_PRIORITY.HIGH]: '#FFD121',
  [TASK_PRIORITY.URGENT]: '#ED5A5A',
};

export const DUOTONE_COLORS = {
  ORGANIZATION: '#F55053',
  ACCOUNTS: '#434FF1',
};

export const TASK_ENTITIES = {
  ORGANIZATION: 'ORGANIZATION',
  ACCOUNTS: 'ACCOUNT',
};

export const LINKING_TYPES = {
  RELATES_TO: 'RELATES_TO',
  BLOCKED_BY: 'BLOCKED_BY',
  BLOCKS: 'BLOCKS',
};

export const TASK_BOARD_STATUS_LANES = [
  {
    title: TASK_STATUS_MAPPING[TASK_STATUS.OPEN].displayName,
    key: TASK_STATUS.OPEN,
    borderColor: TASK_STATUS_COLORS.OPEN_COLOR,
  },
  {
    title: TASK_STATUS_MAPPING[TASK_STATUS.PLANNED].displayName,
    key: TASK_STATUS.PLANNED,
    borderColor: TASK_STATUS_COLORS.PLANNED_COLOR,
  },
  {
    title: TASK_STATUS_MAPPING[TASK_STATUS.IN_PROGRESS].displayName,
    key: TASK_STATUS.IN_PROGRESS,
    borderColor: TASK_STATUS_COLORS.IN_PROGRESS_COLOR,
  },
  {
    title: TASK_STATUS_MAPPING[TASK_STATUS.BLOCKED].displayName,
    key: TASK_STATUS.BLOCKED,
    borderColor: TASK_STATUS_COLORS.BLOCKED_COLOR,
  },
  {
    title: TASK_STATUS_MAPPING[TASK_STATUS.COMPLETED].displayName,
    key: TASK_STATUS.COMPLETED,
    borderColor: TASK_STATUS_COLORS.COMPLETE_COLOR,
  },
];

export const TASK_BOARD_PRIORITY_LANES = [
  {
    title: TASK_PRIORITY_MAPPING[TASK_PRIORITY.NONE].value,
    key: TASK_PRIORITY.NONE,
    borderColor: TASK_PRIORITY_COLORS[TASK_PRIORITY.NONE],
  },
  {
    title: TASK_PRIORITY_MAPPING[TASK_PRIORITY.LOW].value,
    key: TASK_PRIORITY.LOW,
    borderColor: TASK_PRIORITY_COLORS[TASK_PRIORITY.LOW],
  },
  {
    title: TASK_PRIORITY_MAPPING[TASK_PRIORITY.NORMAL].value,
    key: TASK_PRIORITY.NORMAL,
    borderColor: TASK_PRIORITY_COLORS[TASK_PRIORITY.NORMAL],
  },
  {
    title: TASK_PRIORITY_MAPPING[TASK_PRIORITY.HIGH].value,
    key: TASK_PRIORITY.HIGH,
    borderColor: TASK_PRIORITY_COLORS[TASK_PRIORITY.HIGH],
  },
  {
    title: TASK_PRIORITY_MAPPING[TASK_PRIORITY.URGENT].value,
    key: TASK_PRIORITY.URGENT,
    borderColor: TASK_PRIORITY_COLORS[TASK_PRIORITY.URGENT],
  },
];

export const TASK_BOARD_VIEW_TYPE = {
  STATUS: 'status',
  PRIORITY: 'priority',
};

export const VIEW_MODE_TYPE_MAPPING = {
  [TASK_VIEW_MODES.BOARD_STATUS]: 'status',
  [TASK_VIEW_MODES.BOARD_PRIORITY]: 'priority',
};

export const VIEW_MODE_LANES_MAPPING = {
  [TASK_VIEW_MODES.BOARD_STATUS]: TASK_BOARD_STATUS_LANES,
  [TASK_VIEW_MODES.BOARD_PRIORITY]: TASK_BOARD_PRIORITY_LANES,
};

export const VIEW_MODE_TYPE_LANES_MAPPING = {
  [TASK_BOARD_VIEW_TYPE.STATUS]: TASK_BOARD_STATUS_LANES,
  [TASK_BOARD_VIEW_TYPE.PRIORITY]: TASK_BOARD_PRIORITY_LANES,
};

export const TASK_BOARD_PAGE_SIZE = 10;

export const USER_SELECTION_TYPE = {
  USER_FIELD: 'User Role',
  USER: 'User',
};

export const DEFAULT_PAGE_SIZE = 20;

export const DEFAULT_TASKS_PAGINATION = {
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
};
